import { JSX, useId } from "react";
import hailIcon from "./hagelschade-icon.png";

export const SvgHailIcon = (): JSX.Element => {
    const maskId = `hagelschade-mask-${useId().replaceAll(":", "")}`;
    const filterId = `hagelschade-invert-${useId().replaceAll(":", "")}`;

    return (
        <svg
            width="55px"
            height="55px"
            viewBox="0 0 133 133"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <filter id={filterId} colorInterpolationFilters="sRGB">
                    <feColorMatrix
                        type="matrix"
                        values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0"
                    />
                </filter>
                <mask
                    id={maskId}
                    maskUnits="userSpaceOnUse"
                    maskContentUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="133"
                    height="133"
                >
                    <image
                        href={hailIcon}
                        width="133"
                        height="133"
                        filter={`url(#${filterId})`}
                    />
                </mask>
            </defs>
            <rect
                width="133"
                height="133"
                className="fill-primary"
                mask={`url(#${maskId})`}
            />
            <circle cx="58" cy="37" r="5.5" className="fill-secondary" />
            <circle cx="66" cy="55.5" r="5.5" className="fill-secondary" />
            <circle cx="87.5" cy="63.5" r="5" className="fill-secondary" />
        </svg>
    );
};
